import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle, WarningCircle, CircleNotch } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const token = params.get("token");
    if (!token) { setState("error"); return; }
    api.get("/auth/verify-email", { params: { token } })
      .then(() => setState("ok"))
      .catch(() => setState("error"));
  }, [params]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-slate-50" data-testid="verify-email-page">
      <div className="max-w-md w-full text-center bg-white rounded-2xl border p-8 shadow-sm">
        <img src="/logo.png" alt="Housetag" className="w-14 h-14 mx-auto mb-5 object-contain" />
        {state === "loading" && (
          <div className="flex flex-col items-center gap-3 text-slate-600" data-testid="verify-email-loading">
            <CircleNotch size={32} className="animate-spin text-purple-600" />
            <p>Verifica in corso...</p>
          </div>
        )}
        {state === "ok" && (
          <div className="flex flex-col items-center gap-3" data-testid="verify-email-success">
            <CheckCircle size={44} weight="duotone" className="text-emerald-600" />
            <p className="text-slate-800 leading-relaxed">
              Email confermata! Housetag verificherà ora il tuo account e riceverai una mail di attivazione.
            </p>
          </div>
        )}
        {state === "error" && (
          <div className="flex flex-col items-center gap-3" data-testid="verify-email-error">
            <WarningCircle size={44} weight="duotone" className="text-red-600" />
            <p className="text-slate-800">Link non valido o già utilizzato.</p>
          </div>
        )}
        {state !== "loading" && (
          <Link to="/" className="inline-block mt-6">
            <Button variant="outline" data-testid="verify-email-home-link">Torna alla homepage</Button>
          </Link>
        )}
      </div>
    </div>
  );
}
